import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StarFilled } from "@faire/web--source/slate/icons/foundation/StarFilled";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
export var MaybeBrandReviewTile = function(props) {
    var rating = props.rating;
    if (!rating) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        "data-test-id": "brand-review-tile",
        children: [
            /*#__PURE__*/ _jsx(StarFilled, {
                fontSize: "12px"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: 2
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: rating
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            })
        ]
    });
};
